<template>

  <div>

    <t-dialog-import-models v-if="showDialogModels" @onSubmit="onImported" :type="type"/>

    <b-modal
        :id="'modal-import-'+type"
        ref="modal"
        title="Escolha uma opção desejada"
        @show="onShow"
        hide-footer
        @hidden="onHidden">

      <div class="grid-menu grid-menu-2col p-4">
        <div class="no-gutters row d-flex justify-content-center">


          <div class="col-sm-4" v-if="!disableImport">
            <t-button @click="onImport"
                      :class="{'border-bottom':disableDuplicate}"
                      class="border-left border-top btn-icon-vertical btn-square btn-transition btn btn-outline-primary">
              <i class="lnr-magic-wand btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Usar Modelo
            </t-button>

          </div>

          <div class="col-sm-4" v-if="!disableDuplicate">
            <t-button @click="onDuplicate"
                      class="border-right border-top border-bottom btn-icon-vertical btn-square btn-transition btn btn-outline-primary">
              <i class="lnr-layers btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Duplicar
            </t-button>

          </div>

          <div class="col-sm-4" v-if="!disableNew">
            <t-button :to="newTo"
                      :class="{'border-right':disableDuplicate}"
                      class="border-bottom border-top btn-icon-vertical btn-square btn-transition btn btn-outline-primary">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Em branco
            </t-button>

          </div>


        </div>

      </div>


    </b-modal>

  </div>

</template>
<script>
import TDialogImportModels from "@/components/template/dialog/t-dialog-import-models";

export default {
  name: 't-dialog-import',
  components: {TDialogImportModels},
  data() {
    return {
      status: "",
      showDialogModels: false,
    }
  },
  props: {
    type: String,
    title: String,
    disableImport: Boolean,
    disableDuplicate: Boolean,
    disableNew: Boolean,
    newTo: String,

  },
  computed: {
    onStatus() {
      return this.status
    },
  },
  methods: {

    onShow() {

      this.$emit('show')

    },
    onHidden() {
      this.$emit('hidden')
    },
    onImport() {
      this.showDialogModels = true

      setTimeout(() => {
        this.$bvModal.show('modal-import-models')
      }, 100)


    },
    onImported(item) {
      this.$emit('onImported', item)

      //this.$bvModal.hide('modal-import-' + this.type)
    },
    onDuplicate() {
      this.$bvModal.hide('modal-import-' + this.type)
      this.$emit('onDuplicate')
    },

  }
}
</script>
